import AdminDashboard from "./AdminDashboard.jsx";
import Profile from "../panel/user/Profile.jsx";
import ManagerTicketList from "./ManagerTicketList.jsx";
import ManagerTicketDetail from "./ManagerTicketDetail.jsx";
import StoreManagementList from "./storemanagement/StoreManagementList.jsx";
import ConsultationList from "./ConsultationList.jsx";
import ConsultationDetail from "./ConsultationDetail.jsx";
import AdminCommissions from "./finance/AdminCommissions.jsx";
import AdminTransactions from "./finance/AdminTransactions.jsx";
import Provinces from "./coreBasics/Provinces.jsx";
import Cities from "./coreBasics/Cities.jsx";
import StoreTypes from "./coreBasics/StoreTypes.jsx";
import Plans from "./coreBasics/Plans.jsx";
import AddUser from "./user/AddUser.jsx";
import CustomerList from "./user/CustomerList.jsx";
import UserList from "./user/UserList.jsx";
import Templates from "./coreBasics/Templates.jsx";
import TemplateSections from "./coreBasics/TemplateSections.jsx";
import AdminWithdrawalRequests from "./finance/AdminWithdrawalList.jsx";
import DiscountCodeCreate from "./DiscountCodeCreate.jsx";
import DiscountCodeList from "./DiscountCodeList.jsx";
import ChatArchive from "../panel/user/ChatArchive.jsx";
import ChatPage from "../panel/user/ChatPage.jsx";
import ProMajaziAdmin from "../proMajazi/admin/ProMajaziAdmin.jsx";

// نگاشت id هر آیتم منو به کامپوننت صفحه‌ی مربوطه
// این همون idهایی هستن که در NAV_DATA داخل Sidebar.jsx استفاده شده‌اند
export const PAGE_ROUTES = [
  { id: "AdminDashboard", Component: AdminDashboard },
  { id: "profile", Component: Profile },
  { id: "storeManagementList", Component: StoreManagementList },

  { id: "provinces", Component: Provinces },
  { id: "cities", Component: Cities },
  { id: "storeTypes", Component: StoreTypes },
  { id: "plans", Component: Plans },
  { id: "AddUser", Component: AddUser },
  { id: "CustomerList", Component: CustomerList },
  { id: "UserList", Component: UserList },
  { id: "Templates", Component: Templates },
  { id: "TemplateSections", Component: TemplateSections },
  { id: "withdraw-requests", Component: AdminWithdrawalRequests },
  { id: "create-discount", Component: DiscountCodeCreate },
  { id: "discount-list", Component: DiscountCodeList },

  {
    id: "deposits",
    Component: AdminTransactions,
  },

  {
    id: "sales-commission",
    Component: AdminCommissions,
  },
  {
    id: "ticket-archive",
    Component: ManagerTicketList,
    children: [{ path: ":ticketId", Component: ManagerTicketDetail }],
  },
  {
    id: "consultation",
    Component: ConsultationList,
    children: [{ path: ":consultationId", Component: ConsultationDetail }],
  },
  {
    id: "chat-archive",
    Component: ChatArchive,
    children: [{ path: ":chatId", Component: ChatPage }],
  },

  {
    id: "pro-majazi",
    Component: ProMajaziAdmin,
  },
];

// برای سازگاری با کدهای قدیمی که هنوز از PAGE_COMPONENTS استفاده می‌کنن
// (مثلاً اگه جای دیگه‌ای از پروژه بهش رفرنس داده شده)
export const PAGE_COMPONENTS = Object.fromEntries(
  PAGE_ROUTES.map(({ id, Component }) => [id, Component]),
);
